<template>
  <div class="bn-wrap">
    <div v-if="!headBanner" class="bn-container">
      <div class="bn-bd">
        <h2 v-if="title" v-html="title" />
      </div>
    </div>
    <img v-if="headBanner" :src="headBanner" :alt="title">
    <div v-if="isInforShow" class="default-infor">
      <div v-if="insuranceInfor.companyName" class="company-name after-bdr">
        {{ insuranceInfor.companyName }}
      </div>
      <div v-if="insuranceInfor.name" class="insurance-name">
        {{ insuranceInfor.name }}
      </div>
    </div>
    <a
      v-if="insuranceInfor.companyIntroductionUrl"
      class="company-itr"
      :href="insuranceInfor.companyIntroductionUrl"
    >公司介绍</a>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    headBanner: {
      type: String,
      default: '',
    },
    insuranceInfor: {
      type: Object,
      default() {
        return {}
      },
    },
    conditions: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    isInforShow() {
      const { conditions, headBanner } = this
      // (默认banner && 非对比计划书) || 通用头图模版（common_bn=1）
      return (
        (conditions.defaultBanner && !conditions.isContrastPb) ||
        /common_bn/.test(headBanner)
      )
    },
  },
}
</script>

<style lang="postcss" scoped>
@import 'variable.css';

.bn-wrap {
  overflow: hidden;
  position: relative;
  width: 100%;
  .bn-container {
    overflow: hidden;
    height: 115px;
  }
  img {
    width: 100%;
    vertical-align: middle;
  }
  .bn-bd {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 115px;
    padding-top: 8px;
    text-align: center;
    color: #fff;
    h2 {
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 90%;
      max-height: 88px;
      transform: translate(-50%, -50%);
      margin-top: -11px;
      font-size: 24px;
    }
  }
}
</style>
